import { Injectable, InjectionToken } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { ShopeeAttributeComponent } from '../forms/produtos/shopee/shopee-attribute/shopee-attribute.component';
import { ShopeeVarTierComponent } from '../forms/produtos/shopee/shopee-var-tier/shopee-var-tier.component';
import { REGISTRY } from '../interfaces/registry-services';
import { ObjectUtil } from '../system-utils/utils/ObjectUtil';
import { DialogService } from './dialog.service';
import { HTTPService } from './http.service';
import { SnackbarService } from './snackbar.service';

@Injectable()
export class ShopeeServices {
    constructor(private http:HTTPService, private snackBar:SnackbarService, private dialogServices:DialogService){

    }

    sub:Subscription;
    sub2:Subscription;

    ngOnDestroy(){
        if (this.sub!= null ) {this.sub.unsubscribe();}
        if (this.sub2!= null ) {this.sub2.unsubscribe();}
    }


    openTiers(data){
        return new Promise((resolve,reject)=>{
            this.dialogServices.disableClose = true;

            this.dialogServices.openGenericDialog(ShopeeVarTierComponent,data,()=>{
                resolve(true);
            });
        });

    }

    // getAttributes(data){
    //     return new Promise((resolve,reject)=>{
            
    //         let arrayData:object[] = [];
    //         let dataObject = data[0];

    //         Object.keys(dataObject).forEach(key=>{
    //             if ( ObjectUtil.isNotEmpty(dataObject[key])){
    //                 arrayData.push({
    //                     'key':'@'+key.toUpperCase(),
    //                     'value': dataObject[key]
    //                 });
    //             }
                
    //         });
            
    //         let ob = {
    //             expressao : 'getRequestData(\"GetAttributes_V2\",\"Product\",?getFullShopeeParams({@CODECOMPANY},/api/v2/product/get_attributes)&category_id={@CATEGORY_ID}&language=pt-br,\"GET\",\"null\",\"null\",\"47\")',
    //             novo: true,
    //             codecontract: dataObject['CODECONTRACT'],
    //             codecompany: dataObject['CODECOMPANY'],
    //             codemktp: 47,
    //             values: arrayData
    //         }
        
            
    //         this.dialogServices.disableClose = true;
    //         this.sub2 = this.http.post(ob, 'FormulaServices/test',false,true,true).subscribe(formula=>{
    //             let data = {
    //                 product: dataObject,
    //                 shopeeresult: formula
    //             }

    //             this.dialogServices.openGenericDialog(ShopeeAttributeComponent,data,()=>{
    //                 resolve(true);
    //             });
    //         },error=>{
    //             reject(error);
    //         });
    
    //     });
        
    // }


    getAttributes2(data){
        return new Promise((resolve,reject)=>{
            
            let arrayData:object[] = [];
            
            Object.keys(data).forEach(key=>{
                if ( ObjectUtil.isNotEmpty(data[key])){
                    arrayData.push({
                        'key':'@'+key.toUpperCase(),
                        'value': data[key]
                    });
                }
                
            });
            
            let ob = {
                expressao : 'getRequestData(\"GetAttributes_V2\",\"Product\",?getFullShopeeParams({@CODECOMPANY},/api/v2/product/get_attribute_tree)&category_id_list={@CATEGORY_ID}&language=pt-br,\"GET\",\"null\",\"null\",\"47\")',
                novo: true,
                codecontract: data['CODECONTRACT'],
                codecompany: data['CODECOMPANY'],
                codemktp: 47,
                values: arrayData
            }
        
            
            
            this.sub2 = this.http.post(ob, 'FormulaServices/test',false,true,true).subscribe(formula=>{
                resolve(formula);
            },error=>{
                reject(error);
            });
    
        });
        
    }

    
}